/**
 * T098: useUpdateTag Hook
 * Mutation hook for updating tags
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateTag, type UpdateTagInput } from '@/services/tags'
import { queryKeys } from '@/lib/query-keys'

interface UpdateTagParams {
  id: string
  input: UpdateTagInput
}

export function useUpdateTag() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, input }: UpdateTagParams) => updateTag(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
    },
  })
}
